import { DendromapLoader } from '@repo/ui/components/dendromap-loader';
import { lazy, Suspense } from 'react';


const IntegratedMapLayout = lazy(() =>
  import('@repo/ui/features/inventaires/map-view/integrated-map-layout').then((mod) => ({
    default: mod.IntegratedMapLayout,
  })),
);

const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string | undefined;
const GOOGLE_MAPS_MAP_ID = import.meta.env.VITE_GOOGLE_MAPS_MAP_ID as string | undefined;

export default function InventaireMapPage() {
  return (

    <Suspense fallback={<DendromapLoader message="Chargement de la carte..." />}>
      <IntegratedMapLayout
        //center={[36.8065, 10.1815]}
        radius={10000}
        defaultMapProvider="google"
        showProviderSelector
        googleMapsApiKey={GOOGLE_MAPS_API_KEY}
        googleMapsMapId={GOOGLE_MAPS_MAP_ID}
      />
    </Suspense>

  );
}

